import React, { Component } from 'react';
import { Row, Col, Button, Icon, Alert, Collapse } from 'antd';

export default class ResourceIndicatorLoadingFailure extends Component {
    constructor(props) { super(props); }
    render() {
        return (
            <div>
                <Row type='flex' justify='center' align='middle' style={{ margin: '0px 0px 20px 0px' }}>
                    <Col>
                        <Alert
                            type='error'
                            style={{ width: '260px', borderRadius: '5px', textAlign: 'center' }}
                            message={(
                                <span className='ss-components-error-title'>
                                    <Icon type='warning' style={{ marginRight: '8px' }} />
                                    {'Unexpected Error'}
                                </span>
                            )}
                        />
                    </Col>
                </Row>
                <Row style={{ marginBottom: '6px' }}>
                    <Col>
                        <span className='ss-components-error-sub-title'>
                            {'Unable to load common resources:'}
                        </span>
                    </Col>
                </Row>
                <Row style={{ marginBottom: '20px' }}>
                    <Col>
                        <span className='ss-components-error-assistance'>
                            {'Essential resources failed to load. Please retry or contact support.'}
                        </span>
                    </Col>
                </Row>
                <Row type='flex' justify='center' align='middle' style={{ marginBottom: '20px' }}>
                    <Col>
                        <Button
                            type='danger'
                            icon='reload'
                            style={{ width: '260px' }}
                            onClick={() => window.location.href = window.location.pathname}
                        >
                            {'Retry'}
                        </Button>
                    </Col>
                </Row>
                <Row type='flex' justify='center' align='middle'>
                    <Col>
                                <div style={{ lineHeight: '17px' }}>
                                    <div style={{ fontStyle: 'italic', marginBottom: '15px' }}>
                                        {'Contact FTSP Support at:'}
                                    </div>
		<div>
                                            <span className='ss-components-help-highlight'>
                                                <a href='mailto:FTSP.Support@tsa.dhs.gov'>
                                                    {'FTSP.Support@tsa.dhs.gov'}
                                                </a>
                                            </span>
		</div>
                                </div>
                    </Col>
                </Row>
            </div>
        )
    }
}